import { render, staticRenderFns } from "./awaiting-payment-list.vue?vue&type=template&id=2d12b334"
import script from "./awaiting-payment-list.vue?vue&type=script&lang=js"
export * from "./awaiting-payment-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports